import { createHashRouter, } from 'react-router-dom'
import App from '../App'
import ProtectedRoutes from '../components/ProtectedRoutes/ProtectedRoutes'
import { Campaign, EnquireDashboard, Enquiry, LeadDetail, NewLead, Organizaition, Overview, Profile, SettingsMenu, SettingUsers, SignIn, Status, Users } from "../pages"
const router = createHashRouter([
    {
        path: "/",
        element:
            <ProtectedRoutes>
                <App />
            </ProtectedRoutes>
        ,
        children: [
            { index: true, element: <Overview /> },
            { path: "enquiry", element: <EnquireDashboard /> },
            { path: "enquiry/:lead_id", element: <LeadDetail /> },
            { path: "enquiry/new_lead", element: <NewLead /> },
            { path: "reports", element: <Enquiry /> },
            { path: "reports/users", element: <Users /> },
            { path: "settings", element: <Organizaition /> },
            { path: "settings/menu", element: <SettingsMenu /> },
            { path: "settings/users", element: <SettingUsers /> },
            { path: "settings/campaign", element: <Campaign /> },
            { path: "settings/status", element: <Status /> },
            { path: "profile", element: <Profile /> },

        ]
    },
    { path: 'sign_in', element: <SignIn /> },

])
export default router